import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }
const _hoisted_2 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_3 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isEditBulkModalOpened,
    "no-padding": true,
    spots: _ctx.spotsToEdit,
    spaceId: _ctx.parkingSpaceId,
    title: "Edit multiple parking spots",
    onToggleModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_input_field, {
                    modelValue: _ctx.parkingSpot.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parkingSpot.name) = $event)),
                    label: _ctx.$t('Label'),
                    errorMessage: _ctx.v$?.parkingSpot['name']?.$errors[0]?.$message,
                    isError: _ctx.v$?.parkingSpot['name']?.$error,
                    required: true
                  }, null, 8, ["modelValue", "label", "errorMessage", "isError"]),
                  _createVNode(_component_input_field, {
                    modelValue: _ctx.parkingSpot.startNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parkingSpot.startNumber) = $event)),
                    label: "Start Number",
                    errorMessage: _ctx.v$?.parkingSpot['startNumber']?.$errors[0]?.$message,
                    isError: _ctx.v$?.parkingSpot['startNumber']?.$error,
                    required: true
                  }, null, 8, ["modelValue", "errorMessage", "isError"]),
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("ParkingSpots.Type")), 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isParkingSpotListLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.parkingSpot.typeId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.parkingSpot.typeId) = $event)),
                          class: _normalizeClass(`mt-1 w-full`),
                          options: _ctx.parkingSpotTypes,
                          reduce: (space) => space.id,
                          label: "name"
                        }, null, 8, ["modelValue", "options", "reduce"]))
                  ])
                ]),
                _createVNode(_component_checkbox_input, {
                  modelValue: _ctx.parkingSpot.public,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.parkingSpot.public) = $event)),
                  "is-checked": _ctx.parkingSpot.public,
                  label: _ctx.$t('ParkingSpots.Public')
                }, null, 8, ["modelValue", "is-checked", "label"]),
                _createVNode(_component_checkbox_input, {
                  modelValue: _ctx.parkingSpot.integration,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.parkingSpot.integration) = $event)),
                  "is-checked": _ctx.parkingSpot.integration,
                  label: _ctx.$t('ParkingSpots.Integration')
                }, null, 8, ["modelValue", "is-checked", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-displayed", "spots", "spaceId"]))
}